import React, { createContext, useContext, useState, useMemo, useCallback } from "react";

const STRINGS = {
  ar: {
    appName: "عدل",
    appTagline: "مساحة عملك القانونية",
    nav_library: "المكتبة",
    nav_research: "البحث في قرارك",
    library_panel_view: "المستند",
    library_panel_search: "البحث القانوني",
    nav_chat: "المحادثة",
    nav_summary: "الملخصات",
    nav_draft: "الصياغة",
    nav_search: "البحث",
    nav_cases: "القضايا",
    cases_empty_title: "لا توجد قضايا بعد",
    cases_empty_sub: "أنشئ قضية لتجميع المستندات والسياق والمحادثة في مكان واحد",
    case_create: "قضية جديدة",
    case_title: "عنوان القضية",
    case_description: "تفاصيل القضية",
    case_practice_area: "نوع القضية",
    case_open: "فتح القضية",
    case_back: "العودة للقضايا",
    case_documents: "مستندات القضية",
    case_knowledge: "المعرفة والمهارات",
    case_advanced_settings: "إعدادات متقدمة",
    case_advanced_settings_hint: "خصّص معرفة القضية ومهارات المساعد",
    case_onboarding_settings_prompt: "أكمل إعداد معرفة القضية لتحصل على مساعدة أدق.",
    case_open_advanced_settings: "فتح الإعدادات المتقدمة",
    case_chat: "محادثة القضية",
    case_draft: "صياغة القضية",
    case_draft_suggestions: "اقتراحات المسودات",
    case_draft_suggestions_refresh: "تحديث الاقتراحات",
    case_draft_use_suggestion: "تم تطبيق الاقتراح — راجع النموذج ثم أنشئ المسودة",
    case_draft_suggestions_empty: "لا توجد اقتراحات بعد. أضف مستندات أو معرفة للقضية ثم حدّث.",
    case_draft_suggestions_failed: "تعذّر تحميل اقتراحات المسودات",
    case_doc_role_draft: "مسودات وصيغ القضية",
    case_doc_role_draft_hint: "تُنشأ من تبويب الصياغة — لا يمكن رفع ملفات هنا",
    case_doc_role_law: "قوانين",
    case_doc_role_regulation: "أنظمة وتشريعات",
    case_doc_role_case_detail: "تفاصيل القضية",
    case_doc_role_reference: "مراجع",
    case_link_library: "من المكتبة",
    case_unlink: "إزالة من القضية",
    case_onboarding_banner: "عزّز فهم المساعد — أجب على أسئلة عن **وقائع القضية وظروفها** (القانون مأخوذ من المستندات المرفوعة)",
    case_onboarding_start: "بدء الأسئلة",
    case_onboarding_skip: "تخطي",
    case_onboarding_submit: "حفظ الإجابات",
    case_onboarding_details: "تفاصيل إضافية",
    case_onboarding_details_placeholder: "أضف سياقاً أو ملاحظات (اختياري)",
    case_onboarding_select_option: "يرجى اختيار إجابة لكل سؤال",
    case_knowledge_placeholder: "ستظهر معرفة القضية هنا بعد الإجابة على الأسئلة أو يمكنك كتابتها يدوياً",
    case_skills_add: "إضافة مهارة",
    case_skill_title: "عنوان المهارة",
    case_skill_content: "المحتوى",
    case_save: "حفظ",
    case_archive: "أرشفة",
    case_docs_count: "{n} مستند",
    case_onboarding_pending: "بانتظار الأسئلة",
    case_onboarding_in_progress: "أسئلة جارية",
    case_onboarding_completed: "مكتمل",
    case_onboarding_skipped: "تم التخطي",
    practice_civil: "قضية حقوقية",
    practice_criminal: "قضية جزائية",
    case_create_step_info: "معلومات القضية",
    case_create_step_docs: "المستندات",
    case_qarark_section: "مصادر من قرارك",
    case_qarark_loading: "جاري البحث في قرارك عن تشريعات ذات صلة…",
    case_qarark_empty: "لم تُعثر على نتائج. جرّب استعلاماً آخر أو تابع بدون مستندات من قرارك.",
    case_qarark_not_connected: "اربط حساب قرارك لاقتراح تشريعات وأحكام ذات صلة تلقائياً.",
    case_qarark_connect_btn: "ربط قرارك",
    case_qarark_search_more: "بحث إضافي",
    case_qarark_search_placeholder: "استعلام بحث في قرارك…",
    case_qarark_suggested_queries: "استعلامات مقترحة",
    case_qarark_role_label: "الدور",
    case_qarark_include: "إضافة المحدد للقضية",
    case_qarark_included_count: "محدد: {count}",
    case_qarark_import_success: "تمت إضافة {count} مستنداً من قرارك",
    case_qarark_find_section: "البحث في قرارك",
    case_create_submit: "إنشاء القضية",
    case_created: "تم إنشاء القضية",
    case_saved: "تم الحفظ",
    case_questions_loading: "جاري توليد الأسئلة…",
    case_questions_error: "تعذر توليد الأسئلة",
    case_select_docs: "اختر من المكتبة",
    case_next: "التالي",
    case_prev: "السابق",
    upload: "رفع مستند",
    drop_here: "اسحب الملف هنا أو انقر للاختيار",
    supported: "PDF · Word · صور · TXT — حتى 50 ميجابايت",
    uploading: "جارٍ التحليل واستخراج النص…",
    docs_empty_title: "لا توجد مستندات بعد",
    docs_empty_sub: "ارفع أول وثيقة قانونية لتبدأ التحليل",
    select_model: "النموذج",
    pages: "صفحات",
    chars: "حرف",
    language: "اللغة",
    delete: "حذف",
    view: "فتح",
    new_chat: "محادثة جديدة",
    ask_placeholder: "اسأل عن البنود، الالتزامات، التواريخ، الأطراف…",
    send: "إرسال",
    summarize: "تلخيص",
    summarize_style: "نمط التلخيص",
    style_comprehensive: "شامل",
    style_brief: "موجز",
    style_bullets: "نقاط",
    style_key_clauses: "بنود رئيسية",
    generate_summary: "إنشاء الملخص",
    draft_title: "صياغة وثيقة قانونية",
    doc_type: "نوع الوثيقة",
    instructions: "التعليمات والمتطلبات",
    parties: "الأطراف",
    jurisdiction: "الاختصاص القضائي",
    operating_country: "دولة الممارسة",
    operating_country_hint: "تؤثر على صياغة المسودات والمصطلحات القانونية والاقتراحات في المنصة.",
    operating_country_saved: "تم تحديث دولة الممارسة",
    qarark_jordan_only_warning:
      "تنبيه: قرارك يعرض تشريعات وأحكاماً أردنية فقط. تحقق من التشريع المحلي في دولتك قبل الاعتماد على النتائج.",
    generate: "إنشاء",
    draft_saved: "تم حفظ المسودة في المكتبة",
    draft_preview: "معاينة",
    draft_edit: "تحرير",
    draft_save: "حفظ",
    draft_saving: "جارٍ الحفظ…",
    draft_updated: "تم حفظ التعديلات",
    draft_unsaved: "تعديلات غير محفوظة",
    draft_export_txt: "تصدير TXT",
    draft_export_docx: "تصدير Word",
    draft_exporting: "جارٍ التصدير…",
    draft_exported: "تم التصدير",
    draft_previous: "مسودات سابقة",
    draft_new: "مسودة جديدة",
    draft_no_previous: "لا توجد مسودات محفوظة بعد. أنشئ وثيقة وسيتم حفظها هنا.",
    draft_empty_state: "املأ النموذج ثم اضغط إنشاء، أو اختر مسودة سابقة",
    draft_empty_hint: "أو اختر مسودة من القائمة على اليسار",
    draft_load_failed: "تعذّر تحميل المسودة",
    draft_discard_confirm: "لديك تعديلات غير محفوظة. هل تريد المتابعة دون حفظ؟",
    search_placeholder: "ابحث في مكتبتك القانونية…",
    use_ai_answer: "إجابة ذكية بالذكاء الاصطناعي",
    results: "النتائج",
    ai_answer: "الإجابة الذكية",
    no_results: "لا توجد نتائج مطابقة",
    matches: "تطابق",
    select_document: "اختر مستنداً للبدء",
    no_document_chat: "محادثة عامة (بدون مستند)",
    hero_title: "ابدأ برفع أول مستند",
    hero_sub: "ارفع وثيقة قانونية أو ابدأ من أحد الخيارات السريعة أدناه.",
    home_welcome: "مرحباً",
    home_sub: "ابحث في قرارك، أو افتح قضية للعمل على مستنداتها وصياغاتها ومحادثتها في مكان واحد.",
    home_open: "فتح",
    home_stat_documents: "مستند",
    home_stat_cases: "قضية",
    home_cases_desc: "نظّم مستندات كل قضية وسياقها وصياغاتها ومحادثتها في مساحة عمل واحدة.",
    home_cases_eyebrow: "مساحة القضايا",
    home_cases_open: "فتح القضايا",
    home_tool_library_desc: "ارفع عقوداً ووثائقك وتصفّحها في مكتبة خاصة.",
    home_tool_research_desc:
      "حوّل سؤالك القانوني إلى بحث متعدد في قرارك، واقرأ المصادر وناقشها.",
    research_title: "بحث قانوني موثّق",
    research_history: "جلسات البحث",
    research_new: "بحث جديد",
    research_no_sessions: "لا توجد جلسات بحث بعد",
    research_source_count: "{n} مصدر",
    research_connect_required: "اربط حساب قرارك أولاً",
    research_query_placeholder:
      "اكتب المسألة القانونية أو السؤال الذي تريد البحث عنه…",
    research_start: "ابدأ البحث المتقدم",
    research_searching: "يجري تحليل السؤال والبحث وحفظ المصادر…",
    research_no_results: "لم يتم العثور على مصادر قابلة للحفظ",
    research_delete_confirm: "هل تريد حذف جلسة البحث؟ ستبقى المستندات المحفوظة.",
    research_empty_title: "ابدأ بسؤال قانوني",
    research_empty_hint:
      "سيحوّل عدل سؤالك إلى عدة استعلامات مناسبة لقرارك ويحفظ أفضل النتائج تلقائياً.",
    research_reader: "قراءة المصدر",
    research_chat: "اسأل عن النتائج",
    research_chat_empty: "ابدأ بحثاً لفتح محادثة موثّقة بمصادره.",
    research_chat_hint: "اسأل عن المصادر المحفوظة في جلسة البحث الحالية.",
    home_tool_chat_desc: "ناقش مستنداتك مع مساعد ذكي — إجابات موثّقة باستشهادات.",
    home_tool_draft_desc: "اصِغ مسودات قانونية، عدّلها، وصدّرها إلى Word.",
    landing_eyebrow: "عدل — مساحة عملك القانونية",
    landing_title: "عقود وقضايا ومستشار ذكي — مدعوم بالذكاء الاصطناعي",
    landing_sub: "ترجم وحلّل العقود، ناقش عملك مع مساعد قانوني مبني على مصادرك، وابنِ مساحات قضايا للتحليل العميق — مع استشهادات يمكنك التحقق منها.",
    landing_cta: "ابدأ مجاناً",
    landing_sign_in: "تسجيل الدخول",
    landing_closing_title: "جاهز لجعل عملك القانوني أكثر كفاءة؟",
    landing_closing_sub: "أنشئ حسابك وابدأ في دقائق — عقود وقضايا ومحادثة ذكية في مساحة واحدة خاصة بك.",
    value_eyebrow: "ماذا يقدّم عدل",
    landing_contracts_title: "العقود",
    landing_contracts_desc: "ارفع عقداً وترجمه بين العربية والإنجليزية، حلّل البنود والمخاطر، واصِغ مسودات جاهزة للتصدير.",
    landing_contracts_b1: "ترجمة قانونية دقيقة",
    landing_contracts_b2: "تحليل البنود والمخاطر",
    landing_contracts_b3: "صياغة وتصدير",
    landing_chat_title: "محادثة ذكية",
    landing_chat_desc: "ناقش مستنداتك وقضاياك مع مساعد يفهم سياق عملك — إجابات مبنية على مصادرك وليست محادثة عامة.",
    landing_chat_b1: "إجابات مبنية على مصادرك",
    landing_chat_b2: "استشهادات قابلة للتحقق",
    landing_chat_b3: "مناقشة القضايا والوثائق",
    landing_cases_title: "القضايا",
    landing_cases_desc: "ابنِ مساحة عمل لكل قضية — اربط القوانين والتشريعات وملفات القضية، وشغّل تحليلاً عميقاً قبل الجلسة أو الاستشارة.",
    landing_cases_b1: "بناء مساحة القضية",
    landing_cases_b2: "ربط المستندات والمصادر",
    landing_cases_b3: "تحليل عميق ومحادثة مخصصة",
    login_title: "مرحباً بعودتك",
    login_sub: "سجّل الدخول للمتابعة إلى مساحة عملك.",
    login_back: "العودة إلى الصفحة الرئيسية",
    login_or: "أو",
    login_google: "المتابعة مع Google",
    login_google_error: "فشل تسجيل الدخول عبر Google",
    auth_callback_loading: "جارٍ إكمال تسجيل الدخول…",
    login_footer: "مساحة عمل آمنة وخاصة — لا أحد يرى مستنداتك غيرك.",
    hiw_nav: "كيف يعمل",
    hiw_go_workspace: "افتح مساحة العمل",
    hiw_title: "كيف يعمل عدل",
    hiw_sub: "مساران واضحان لعملك القانوني: ابحث في قرارك، ثم نظّم التحليل والصياغة والمحادثة داخل القضية.",
    hiw_pillars_eyebrow: "مساحة عمل مبسّطة",
    hiw_pillar_research_title: "البحث في قرارك",
    hiw_pillar_research_desc: "اكتب سؤالك القانوني بلغة طبيعية. ينشئ عدل عدة عمليات بحث عربية، ويحفظ أفضل التشريعات والأحكام، ويتيح لك قراءتها ومناقشتها في جلسة البحث.",
    hiw_pillar_cases_title: "القضايا",
    hiw_pillar_cases_desc: "أنشئ قضية حقوقية أو جزائية، واجمع مستنداتها ومصادرها، ثم استخدم المحادثة والصياغة داخل مساحة القضية نفسها. تتوفر المعرفة والمهارات ضمن الإعدادات المتقدمة.",
    hiw_jurisdiction_eyebrow: "الأردن والدول العربية",
    hiw_jurisdiction_title: "مساعدة قانونية تتكيّف مع بلد ممارستك",
    hiw_jurisdiction_desc: "اختر الأردن أو إحدى دول الخليج المدعومة من إعدادات الحساب. عند تغيير البلد، يكيّف عدل لغة التحليل والتعليمات القانونية وأنواع الصياغة والاختصاص الافتراضي مع النظام القانوني الذي اخترته.",
    hiw_jurisdiction_country_title: "غيّر البلد في أي وقت",
    hiw_jurisdiction_country_desc: "يدعم عدل الأردن والإمارات والسعودية والكويت والبحرين وعُمان وقطر. يُطبَّق اختيارك على المحادثة والصياغة وسياق الذكاء الاصطناعي في مساحة العمل.",
    hiw_jurisdiction_sources_title: "مصادرك القانونية هي الأساس",
    hiw_jurisdiction_sources_desc: "أرفق القوانين والأنظمة والأحكام ذات الصلة ليبني عدل إجاباته عليها باستشهادات. البحث المباشر في قرارك متاح للأردن حالياً، وتظهر ملاحظة واضحة عند استخدامه من بلد آخر.",
    hiw_steps_eyebrow: "سير العمل",
    hiw_step1_title: "ابحث عن المصادر",
    hiw_step1_desc: "اطرح سؤالاً قانونياً ليبحث عدل في قرارك عن التشريعات والأحكام ذات الصلة ويحفظ النتائج للقراءة والمتابعة.",
    hiw_step2_title: "أنشئ نوع القضية",
    hiw_step2_desc: "اختر قضية حقوقية أو قضية جزائية، وأضف الوقائع والمستندات والمصادر المناسبة.",
    hiw_step3_title: "اعمل داخل القضية",
    hiw_step3_desc: "راجع المستندات، ناقش القضية باستشهادات، وأنشئ المسودات وعدّلها وصدّرها إلى Word من مكان واحد.",
    hiw_cases_eyebrow: "أمثلة من الممارسة",
    hiw_cases_title: "كيف يستخدم المحامون عدل",
    hiw_case1_title: "بحث مسألة قانونية",
    hiw_case1_desc: "اكتب المسألة مرة واحدة؛ ينفّذ عدل عدة عمليات بحث في قرارك، ويجمع أفضل المصادر، ويفتح محادثة مرتبطة بجلسة البحث.",
    hiw_case2_title: "إدارة قضية حقوقية أو جزائية",
    hiw_case2_desc: "اختر نوع القضية، واربط القوانين والتشريعات وملفات الوقائع والمراجع، واستكمل معرفة القضية من الإعدادات المتقدمة.",
    hiw_case3_title: "المحادثة والصياغة بسياق القضية",
    hiw_case3_desc: "اسأل عبر جميع مستندات القضية، ثم أنشئ المذكرات واللوائح والصيغ المقترحة واحفظها ضمن القضية وصدّرها إلى Word.",
    hiw_cta_title: "جاهز للبدء؟",
    hiw_cta_sub: "أنشئ حسابك وابدأ بالبحث أو افتح قضيتك الأولى خلال دقائق.",
    hiw_cta_workspace_sub: "تابع من حيث توقفت في مساحة عملك.",
    quick_start: "ابدأ الآن",
    qs_upload: "ارفع مستنداً",
    qs_chat: "اسأل عن مستند",
    qs_draft: "اصغ وثيقة جديدة",
    qs_search: "ابحث في مكتبتك",
    confirm_delete: "هل تريد حذف هذا المستند؟",
    deleted: "تم الحذف",
    upload_success: "تم رفع المستند بنجاح",
    upload_fail: "فشل الرفع",
    streaming: "جارٍ التوليد…",
    copy: "نسخ",
    copied: "تم النسخ",
    history: "السجل",
    no_conversations: "لا توجد محادثات بعد",
    delete_conversation: "حذف هذه المحادثة؟",
    conversation_deleted: "تم حذف المحادثة",
    summary_presets: "اقتراحات سريعة",
    chat_context: "سياق المستندات",
    chat_context_custom: "من المكتبة",
    chat_context_select: "اختر المستندات المستخدمة في المحادثة",
    chat_context_count: "مستند",
    chat_context_none: "لم يتم اختيار مستندات",
    chat_context_select_required: "اختر مستنداً واحداً على الأقل للمحادثة",
    chat_context_upload: "رفع مستند",
    chat_empty_hint: "ارفع مستنداً جديداً أو اختر من المكتبة للبدء بالمحادثة",
    chat_empty_action: "اختيار المستندات",
    chat_context_save: "حفظ",
    chat_search_library: "بحث في المكتبة",
    chat_search_library_hint: "اكتب كلمات البحث في مربع الرسالة ثم اضغط «بحث في المكتبة»",
    chat_prefill_hint: "راجع النص ثم اضغط إرسال",
    library_search_found: "تم العثور على {n} مستنداً في المكتبة",
    library_search_none: "لم يتم العثور على مستندات مطابقة في المكتبة",
    cancel: "إلغاء",
    quick_tasks: "مهام سريعة",
    task_query_placeholder: "اكتب سؤالك القانوني للبحث…",
    task_need_docs: "هذه المهمة تتطلب {n} مستنداً على الأقل",
    citation: "مصدر",
    viewer_search: "بحث في المستند…",
    viewer_prev: "السابق",
    viewer_next: "التالي",
    viewer_page: "صفحة",
    viewer_original: "الأصل",
    viewer_text: "النص",
    viewer_download: "تنزيل",
    viewer_no_file: "الملف الأصلي غير متوفر",
    viewer_docx_hint: "معاينة Word غير مدعومة في المتصفح. يمكنك تنزيل الملف الأصلي.",
    viewer_open_original: "فتح الملف",
    multi_select: "تحديد متعدد",
    selected_docs: "محدد",
    source_library: "مكتبتي",
    source_qarark: "قرارك",
    source_both: "الكل",
    qarark_settings: "ربط قرارك",
    qarark_settings_hint: "أدخل بيانات اشتراكك في qarark.com للبحث في التشريعات.",
    qarark_username: "اسم المستخدم أو الرقم النقابي",
    qarark_password: "كلمة المرور",
    qarark_captcha: "رمز التحقق",
    qarark_connect: "ربط الحساب",
    qarark_disconnect: "قطع الاتصال",
    qarark_connected: "تم ربط قرارك بنجاح",
    qarark_disconnected: "تم قطع اتصال قرارك",
    qarark_connected_as: "متصل كـ",
    qarark_captcha_required: "أدخل رمز التحقق من الصورة",
    qarark_device_limit:
      "قرارك يسمح بجهازين فقط في نفس الوقت. سجّل الخروج من الأجهزة الأخرى على qarark.com أو غيّر كلمة المرور هناك، ثم حاول الربط مجدداً.",
    qarark_rate_limit: "محاولات كثيرة. انتظر دقيقة ثم حاول مرة أخرى.",
    qarark_results: "نتائج قرارك",
    qarark_search_placeholder: "ابحث في قرارك…",
    qarark_search_hint:
      "ابحث في قرارك، اختر المستندات ذات الصلة، احفظها في المكتبة، ثم ناقشها في المحادثة.",
    qarark_load_more: "تحميل المزيد من النتائج",
    qarark_filter_type: "نوع البحث",
    qarark_filter_advanced: "فلاتر متقدمة",
    qarark_filter_legislation: "التشريعات",
    qarark_filter_full: "المحتوى كاملاً",
    qarark_filter_courts: "الأحكام",
    qarark_filter_treaties: "الاتفاقيات",
    qarark_filter_interpretation: "التفسير",
    qarark_filter_number: "رقم التشريع",
    qarark_filter_number_ph: "مثال: 16",
    qarark_filter_year: "سنة التشريع",
    qarark_filter_year_ph: "مثال: 1960",
    qarark_filter_gazette: "رقم الجريدة",
    qarark_filter_gazette_ph: "مثال: 1487",
    qarark_filter_leg_type: "نوع التشريع",
    qarark_filter_validity: "حالة السريان",
    qarark_leg_type_all: "كل الأنواع",
    qarark_leg_type_constitution: "الدستور",
    qarark_leg_type_law: "قانون",
    qarark_leg_type_regulation: "نظام",
    qarark_leg_type_instructions: "تعليمات",
    qarark_leg_type_other: "أخرى",
    qarark_validity_active: "تشريع ساري",
    qarark_validity_repealed: "تشريع ملغي",
    qarark_validity_all: "الكل",
    qarark_filter_court_number: "رقم الحكم",
    qarark_filter_court_year: "سنة الحكم",
    qarark_search_help_btn: "كيف أبحث؟",
    qarark_search_help_title: "كيفية البحث والاسترجاع من قرارك",
    qarark_search_help_intro:
      "دليل للمحامين: اربط حسابك، اكتب المسألة القانونية، ودع عدل يبحث في قرارك ويحفظ المصادر للمطالعة والمحادثة.",
    qarark_search_help_steps_title: "خطوات العمل",
    qarark_search_help_step1:
      "اربط حسابك عبر «ربط قرارك» ببيانات اشتراكك في qarark.com (قد يُطلب رمز التحقق).",
    qarark_search_help_step2:
      "افتح «البحث في قرارك»، واكتب المسألة القانونية أو السؤال الذي تريد بحثه.",
    qarark_search_help_step3:
      "نوع البحث الافتراضي «التشريعات». للبحث بالاسم اكتب مثل: قانون العقوبات، نظام العمل. للبحث بالرقم والسنة استخدم الفلاتر المتقدمة (مثال: 16 و 1960).",
    qarark_search_help_step4:
      "افتح «فلاتر متقدمة» لتحديد: رقم التشريع، السنة، رقم الجريدة، نوع التشريع (قانون/نظام…)، وحالة السريان (ساري/ملغي).",
    qarark_search_help_step5:
      "اضغط «بحث». تظهر حتى 10 نتائج في الصفحة. إن وُجدت صفحات إضافية، اضغط «تحميل المزيد من النتائج» أسفل القائمة.",
    qarark_search_help_step6:
      "حدّد المستندات المناسبة (تحديد الكل أو واحداً واحداً)، ثم «حفظ المحدد في المكتبة» — يُحمَّل النص الكامل للتشريع من قرارك تلقائياً.",
    qarark_search_help_step7:
      "يمكنك أيضاً حفظ مستند واحد عبر «حفظ في المكتبة» بجانب كل نتيجة.",
    qarark_search_help_step8:
      "انتقل إلى «المحادثة» واضغط «محادثة بالمستندات المحفوظة» لطرح أسئلة على النصوص التي حفظتها.",
    qarark_search_help_filters_title: "أنواع البحث والفلاتر",
    qarark_search_help_filter1:
      "التشريعات (افتراضي): الأفضل للبحث باسم القانون أو برقم/سنة التشريع.",
    qarark_search_help_filter2:
      "المحتوى كاملاً: يبحث في التشريعات والأحكام والاتفاقيات معاً — استخدمه عندما لا تجد نتيجة في وضع التشريعات.",
    qarark_search_help_filter3:
      "الأحكام: اختر هذا النوع ثم أدخل رقم الحكم وسنة الحكم في الفلاتر المتقدمة.",
    qarark_search_help_filter4:
      "الاتفاقيات / التفسير: للبحث في هذه الفئات؛ استخدم كلمات البحث في الحقل الرئيسي.",
    qarark_search_help_tips_title: "نصائح",
    qarark_search_help_tip1:
      "مثال: للعثور على قانون العقوبات — ابحث بالاسم «قانون العقوبات»، أو بالرقم 16 والسنة 1960 مع نوع «قانون».",
    qarark_search_help_tip2:
      "إذا ظهرت نتائج قليلة جداً، جرّب «المحتوى كاملاً» أو أزل بعض الفلاتر.",
    qarark_search_help_tip3:
      "عند الحفظ، انتظر قليلاً — القوانين الطويلة قد تستغرق ثوانٍ لتحميل كل المواد.",
    qarark_search_help_tip4:
      "إن لم تظهر نتائج، تأكد من اتصال «ربط قرارك» (قرارك يسمح بجهازين فقط؛ سجّل الخروج من الأجهزة الأخرى إن لزم).",
    qarark_search_help_tip5:
      "إذا حُفظ مستند سابقاً بنص ناقص، احذفه من المكتبة وأعد حفظه من البحث.",
    qarark_select_all: "تحديد الكل",
    qarark_save_selected: "حفظ المحدد في المكتبة",
    qarark_chat_with_saved: "محادثة بالمستندات المحفوظة",
    qarark_saved_badge: "محفوظ",
    qarark_saved_count: "تم حفظ {count} مستند",
    qarark_select_one: "حدّد مستنداً واحداً على الأقل",
    qarark_chat_ready: "تم ضبط سياق المحادثة على المستندات المحفوظة",
    library_results: "نتائج المكتبة",
    save_to_library: "حفظ في المكتبة",
    match_semantic: "دلالي",
    match_keyword: "نصي",
    download_docx: "Word",
    placeholders: {
      contract: "مثال: عقد عمل بين شركة س ومحامي، الراتب 1500 دينار، مدة سنتان…",
      memo: "مثال: مذكرة قانونية حول صحة فسخ عقد إيجار لعدم سداد الأقساط…",
      letter: "مثال: خطاب إنذار للمدين بسداد المبلغ خلال 15 يوماً…",
      demand_letter: "مثال: خطاب إنذار للمدين بسداد 5000 دينار خلال 15 يوماً وإلا سيتم رفع دعوى…",
      official_letter: "مثال: خطاب رسمي إلى دائرة التنفيذ بخصوص متابعة حكم صادر…",
      complaint: "مثال: لائحة دعوى مطالبة مالية بسبب إخلال بالعقد أمام محكمة بداية حقوق عمان…",
      motion: "مثال: لائحة جوابية على لائحة دعوى رقم [____] تفنيداً لادعاءات المدعي…",
      appeal_memo: "مثال: مذكرة استئناف على حكم محكمة البداية الصادر بتاريخ…",
      enforcement_petition: "مثال: محضر طلب تنفيذ لحكم قطعي صادر عن محكمة بداية حقوق عمان…",
      settlement_agreement: "مثال: اتفاقية تسوية بين الطرفين على تقسيط المبلغ المحكوم به…",
      jurisdiction: {
        JO: "المملكة الأردنية الهاشمية",
        AE: "دولة الإمارات العربية المتحدة",
        SA: "المملكة العربية السعودية",
        KW: "دولة الكويت",
        BH: "مملكة البحرين",
        OM: "سلطنة عُمان",
        QA: "دولة قطر",
      },
    },
    types: {
      contract: "عقد",
      complaint: "لائحة دعوى",
      motion: "لائحة جوابية / مذكرة دفاع",
      appeal_memo: "مذكرة استئناف",
      cassation_petition: "لائحة تمييز",
      enforcement_petition: "محضر طلب تنفيذ",
      court_application: "طلب / استدعاء",
      demand_letter: "خطاب إنذار عدلي",
      memo: "مذكرة قانونية",
      official_letter: "خطاب رسمي",
      settlement_agreement: "اتفاقية تسوية",
      agreement: "اتفاقية",
      letter: "خطاب",
      custom: "وثيقة مخصصة",
    },
  },
  en: {
    appName: "Adl",
    appTagline: "Your legal workspace",
    nav_library: "Library",
    nav_research: "Qarark Research",
    library_panel_view: "Document",
    library_panel_search: "Legal search",
    nav_chat: "Chat",
    nav_summary: "Summaries",
    nav_draft: "Drafting",
    nav_search: "Search",
    nav_cases: "Cases",
    cases_empty_title: "No cases yet",
    cases_empty_sub: "Create a case to organize documents, context, and chat in one place",
    case_create: "New case",
    case_title: "Case title",
    case_description: "Case details",
    case_practice_area: "Case type",
    case_open: "Open case",
    case_back: "Back to cases",
    case_documents: "Case documents",
    case_knowledge: "Knowledge & skills",
    case_advanced_settings: "Advanced settings",
    case_advanced_settings_hint: "Customize case knowledge and AI skills",
    case_onboarding_settings_prompt: "Complete case knowledge setup for more precise assistance.",
    case_open_advanced_settings: "Open advanced settings",
    case_chat: "Case chat",
    case_draft: "Case drafting",
    case_draft_suggestions: "Suggested drafts",
    case_draft_suggestions_refresh: "Refresh suggestions",
    case_draft_use_suggestion: "Suggestion applied — review the form and generate",
    case_draft_suggestions_empty: "No suggestions yet. Add case documents or knowledge, then refresh.",
    case_draft_suggestions_failed: "Could not load draft suggestions",
    case_doc_role_draft: "Case drafts & forms",
    case_doc_role_draft_hint: "Created from the Drafting tab — uploads not allowed here",
    case_doc_role_law: "Laws",
    case_doc_role_regulation: "Regulations",
    case_doc_role_case_detail: "Case details",
    case_doc_role_reference: "Reference",
    case_link_library: "From library",
    case_unlink: "Remove from case",
    case_onboarding_banner: "Enhance AI understanding — answer questions about **case facts and circumstances** (law comes from uploaded documents)",
    case_onboarding_start: "Start questions",
    case_onboarding_skip: "Skip",
    case_onboarding_submit: "Save answers",
    case_onboarding_details: "Additional details",
    case_onboarding_details_placeholder: "Add context or notes (optional)",
    case_onboarding_select_option: "Please select an answer for each question",
    case_knowledge_placeholder: "Case knowledge will appear here after onboarding, or you can write it manually",
    case_skills_add: "Add skill",
    case_skill_title: "Skill title",
    case_skill_content: "Content",
    case_save: "Save",
    case_archive: "Archive",
    case_docs_count: "{n} docs",
    case_onboarding_pending: "Questions pending",
    case_onboarding_in_progress: "In progress",
    case_onboarding_completed: "Completed",
    case_onboarding_skipped: "Skipped",
    practice_civil: "Civil case",
    practice_criminal: "Criminal case",
    case_create_step_info: "Case info",
    case_create_step_docs: "Documents",
    case_qarark_section: "Sources from Qarark",
    case_qarark_loading: "Searching Qarark for relevant legislation…",
    case_qarark_empty: "No results found. Try another query or continue without Qarark documents.",
    case_qarark_not_connected: "Connect your Qarark account to automatically suggest relevant legislation and rulings.",
    case_qarark_connect_btn: "Connect Qarark",
    case_qarark_search_more: "Search more",
    case_qarark_search_placeholder: "Search query for Qarark…",
    case_qarark_suggested_queries: "Suggested queries",
    case_qarark_role_label: "Role",
    case_qarark_include: "Add selected to case",
    case_qarark_included_count: "Selected: {count}",
    case_qarark_import_success: "Added {count} document(s) from Qarark",
    case_qarark_find_section: "Find on Qarark",
    case_create_submit: "Create case",
    case_created: "Case created",
    case_saved: "Saved",
    case_questions_loading: "Generating questions…",
    case_questions_error: "Could not generate questions",
    case_select_docs: "Pick from library",
    case_next: "Next",
    case_prev: "Back",
    upload: "Upload Document",
    drop_here: "Drop file here or click to browse",
    supported: "PDF · Word · Images · TXT — up to 50MB",
    uploading: "Analyzing and extracting text…",
    docs_empty_title: "No documents yet",
    docs_empty_sub: "Upload your first legal file to begin",
    select_model: "Model",
    pages: "pages",
    chars: "chars",
    language: "Lang",
    delete: "Delete",
    view: "Open",
    new_chat: "New Chat",
    ask_placeholder: "Ask about clauses, obligations, dates, parties…",
    send: "Send",
    summarize: "Summarize",
    summarize_style: "Summary Style",
    style_comprehensive: "Comprehensive",
    style_brief: "Brief",
    style_bullets: "Bullets",
    style_key_clauses: "Key Clauses",
    generate_summary: "Generate Summary",
    draft_title: "Draft Legal Document",
    doc_type: "Document Type",
    instructions: "Instructions & Requirements",
    parties: "Parties",
    jurisdiction: "Jurisdiction",
    operating_country: "Operating country",
    operating_country_hint: "Affects drafting wording, legal terminology, and AI suggestions across the platform.",
    operating_country_saved: "Operating country updated",
    qarark_jordan_only_warning:
      "Note: Qarark shows Jordanian legislation and court decisions only. Verify local law in your country before relying on results.",
    generate: "Generate",
    draft_saved: "Draft saved to your library",
    draft_preview: "Preview",
    draft_edit: "Edit",
    draft_save: "Save",
    draft_saving: "Saving…",
    draft_updated: "Changes saved",
    draft_unsaved: "Unsaved changes",
    draft_export_txt: "Export TXT",
    draft_export_docx: "Export Word",
    draft_exporting: "Exporting…",
    draft_exported: "Exported",
    draft_previous: "Previous drafts",
    draft_new: "New draft",
    draft_no_previous: "No saved drafts yet. Generate a document and it will appear here.",
    draft_empty_state: "Fill out the form and click generate, or open a previous draft",
    draft_empty_hint: "Or pick a draft from the list on the left",
    draft_load_failed: "Could not load draft",
    draft_discard_confirm: "You have unsaved changes. Continue without saving?",
    search_placeholder: "Search your legal library…",
    use_ai_answer: "AI-powered answer",
    results: "Results",
    ai_answer: "AI Answer",
    no_results: "No matches found",
    matches: "matches",
    select_document: "Select a document to begin",
    no_document_chat: "General chat (no document)",
    hero_title: "Start by uploading your first document",
    hero_sub: "Upload a legal file or pick a quick action below to get going.",
    home_welcome: "Welcome",
    home_sub: "Research Qarark, or open a case to work with its documents, drafting, and chat in one place.",
    home_open: "Open",
    home_stat_documents: "documents",
    home_stat_cases: "cases",
    home_cases_desc: "Organize each case's documents, context, drafting, and chat in one workspace.",
    home_cases_eyebrow: "Matter workspace",
    home_cases_open: "Open cases",
    home_tool_library_desc: "Upload contracts and documents to your private library.",
    home_tool_research_desc:
      "Turn a legal question into multiple Qarark searches, then read and discuss the sources.",
    research_title: "Grounded legal research",
    research_history: "Research sessions",
    research_new: "New research",
    research_no_sessions: "No research sessions yet",
    research_source_count: "{n} sources",
    research_connect_required: "Connect your Qarark account first",
    research_query_placeholder:
      "Describe the legal issue or question you want to research…",
    research_start: "Start advanced research",
    research_searching: "Planning searches, retrieving and saving sources…",
    research_no_results: "No sources could be retrieved and saved",
    research_delete_confirm:
      "Delete this research session? Saved documents will be retained.",
    research_empty_title: "Start with a legal question",
    research_empty_hint:
      "Adl will turn it into Qarark-specific searches and automatically save the strongest results.",
    research_reader: "Source reader",
    research_chat: "Ask about results",
    research_chat_empty: "Start research to open a source-grounded conversation.",
    research_chat_hint: "Ask about the sources saved in this research session.",
    home_tool_chat_desc: "Discuss your documents with a grounded assistant — cited answers.",
    home_tool_draft_desc: "Draft legal documents, refine them, and export to Word.",
    landing_eyebrow: "Adl — your legal workspace",
    landing_title: "Contracts, cases, and counsel — powered by AI",
    landing_sub: "Translate and analyze contracts, discuss your work with a grounded legal assistant, and build case workspaces for deep analysis — with citations you can verify.",
    landing_cta: "Get started free",
    landing_sign_in: "Sign in",
    landing_closing_title: "Ready to make your legal work more efficient?",
    landing_closing_sub: "Create your account and begin in minutes — contracts, cases, and intelligent chat in one private workspace.",
    value_eyebrow: "What Adl does",
    landing_contracts_title: "Contracts",
    landing_contracts_desc: "Upload a contract, translate it between Arabic and English, analyze clauses and risks, and draft export-ready documents.",
    landing_contracts_b1: "Precise legal translation",
    landing_contracts_b2: "Clause and risk analysis",
    landing_contracts_b3: "Drafting and export",
    landing_chat_title: "Intelligent chat",
    landing_chat_desc: "Discuss your documents and cases with an assistant that understands your context — grounded in your sources, not generic chat.",
    landing_chat_b1: "Answers grounded in your sources",
    landing_chat_b2: "Verifiable citations",
    landing_chat_b3: "Discuss cases and documents",
    landing_cases_title: "Cases",
    landing_cases_desc: "Build a workspace for each matter — link laws, regulations, and case files, then run deep analysis before a hearing or consultation.",
    landing_cases_b1: "Build a matter workspace",
    landing_cases_b2: "Link documents and sources",
    landing_cases_b3: "Deep analysis and case chat",
    login_title: "Welcome back",
    login_sub: "Sign in to continue to your workspace.",
    login_back: "← Back to home",
    login_or: "or",
    login_google: "Continue with Google",
    login_google_error: "Google sign in failed",
    auth_callback_loading: "Completing sign in…",
    login_footer: "A secure, private workspace — only you see your documents.",
    hiw_nav: "How it works",
    hiw_go_workspace: "Open workspace",
    hiw_title: "How Adl works",
    hiw_sub: "Two clear paths for legal work: research Qarark, then organize analysis, drafting, and chat inside a case.",
    hiw_pillars_eyebrow: "A focused workspace",
    hiw_pillar_research_title: "Qarark research",
    hiw_pillar_research_desc: "Ask a legal question in natural language. Adl plans several Arabic searches, saves the best legislation and judgments, and lets you read and discuss them within the research session.",
    hiw_pillar_cases_title: "Cases",
    hiw_pillar_cases_desc: "Create a Civil or Criminal case, collect its documents and sources, then use chat and drafting inside that case. Knowledge and skills remain available under Advanced settings.",
    hiw_jurisdiction_eyebrow: "Jordan and the Arab region",
    hiw_jurisdiction_title: "Legal assistance that adapts to your country",
    hiw_jurisdiction_desc: "Choose Jordan or a supported Gulf country from your account settings. When you change countries, Adl adapts its legal language, analysis instructions, drafting types, and default jurisdiction to the selected legal system.",
    hiw_jurisdiction_country_title: "Change country at any time",
    hiw_jurisdiction_country_desc: "Adl supports Jordan, the UAE, Saudi Arabia, Kuwait, Bahrain, Oman, and Qatar. Your selection shapes chat, drafting, and AI context throughout the workspace.",
    hiw_jurisdiction_sources_title: "Your legal sources remain authoritative",
    hiw_jurisdiction_sources_desc: "Attach the relevant laws, regulations, and judgments so Adl can ground answers in them with citations. Direct Qarark research is currently Jordan-focused, with a clear notice for users in other countries.",
    hiw_steps_eyebrow: "The workflow",
    hiw_step1_title: "Research the sources",
    hiw_step1_desc: "Ask a legal question and let Adl search Qarark for relevant legislation and judgments, saving the results for reading and follow-up.",
    hiw_step2_title: "Create the case type",
    hiw_step2_desc: "Choose a Civil or Criminal case, then add the facts, documents, and legal sources that belong to it.",
    hiw_step3_title: "Work inside the case",
    hiw_step3_desc: "Review documents, discuss the case with citations, and generate, edit, and export Word drafts from one place.",
    hiw_cases_eyebrow: "From practice",
    hiw_cases_title: "How lawyers use Adl",
    hiw_case1_title: "Research a legal issue",
    hiw_case1_desc: "Describe the issue once; Adl runs several Qarark searches, collects the best sources, and opens chat scoped to that research session.",
    hiw_case2_title: "Manage a Civil or Criminal case",
    hiw_case2_desc: "Choose the case type, link laws, regulations, factual records, and references, then refine case knowledge from Advanced settings.",
    hiw_case3_title: "Chat and draft with case context",
    hiw_case3_desc: "Ask across every linked case document, generate suggested pleadings and memoranda, save them to the case, and export to Word.",
    hiw_cta_title: "Ready to get started?",
    hiw_cta_sub: "Create your account and start researching or open your first case in minutes.",
    hiw_cta_workspace_sub: "Pick up where you left off in your workspace.",
    quick_start: "Get started",
    qs_upload: "Upload a document",
    qs_chat: "Ask about a document",
    qs_draft: "Draft a new document",
    qs_search: "Search your library",
    confirm_delete: "Delete this document?",
    deleted: "Deleted",
    upload_success: "Document uploaded successfully",
    upload_fail: "Upload failed",
    streaming: "Generating…",
    copy: "Copy",
    copied: "Copied",
    history: "History",
    no_conversations: "No conversations yet",
    delete_conversation: "Delete this conversation?",
    conversation_deleted: "Conversation deleted",
    summary_presets: "Quick prompts",
    chat_context: "Document context",
    chat_context_custom: "From library",
    chat_context_select: "Choose documents to include in chat",
    chat_context_count: "documents",
    chat_context_none: "No documents selected",
    chat_context_select_required: "Select at least one document to chat",
    chat_context_upload: "Upload document",
    chat_empty_hint: "Upload a new document or select from your library to start chatting",
    chat_empty_action: "Choose documents",
    chat_context_save: "Save",
    chat_search_library: "Search library",
    chat_search_library_hint: "Type your search terms in the message box, then click Search library",
    chat_prefill_hint: "Review the text, then click Send",
    library_search_found: "Found {n} matching documents in your library",
    library_search_none: "No matching documents found in your library",
    cancel: "Cancel",
    quick_tasks: "Quick Tasks",
    task_query_placeholder: "Enter your legal question…",
    task_need_docs: "This task requires at least {n} document(s)",
    citation: "Source",
    viewer_search: "Search in document…",
    viewer_prev: "Previous",
    viewer_next: "Next",
    viewer_page: "Page",
    viewer_original: "Original",
    viewer_text: "Text",
    viewer_download: "Download",
    viewer_no_file: "Original file not available",
    viewer_docx_hint: "Word preview is not supported in the browser. Download the original file instead.",
    viewer_open_original: "Open file",
    multi_select: "Multi-select",
    selected_docs: "selected",
    source_library: "My Library",
    source_qarark: "Qarark",
    source_both: "Both",
    qarark_settings: "Connect Qarark",
    qarark_settings_hint: "Enter your qarark.com subscription credentials.",
    qarark_username: "Username or bar ID",
    qarark_password: "Password",
    qarark_captcha: "Captcha code",
    qarark_connect: "Connect",
    qarark_disconnect: "Disconnect",
    qarark_connected: "Qarark connected successfully",
    qarark_disconnected: "Qarark disconnected",
    qarark_connected_as: "Connected as",
    qarark_captcha_required: "Enter the captcha from the image",
    qarark_device_limit:
      "Qarark allows only two active devices. Log out on other devices at qarark.com or change your password there, then try connecting again.",
    qarark_rate_limit: "Too many attempts. Wait a minute and try again.",
    qarark_results: "Qarark Results",
    qarark_search_placeholder: "Search Qarark…",
    qarark_search_hint:
      "Search Qarark, pick relevant documents, save them to your library, then chat with them.",
    qarark_load_more: "Load more results",
    qarark_filter_type: "Search type",
    qarark_filter_advanced: "Advanced filters",
    qarark_filter_legislation: "Legislation",
    qarark_filter_full: "Full content",
    qarark_filter_courts: "Court judgments",
    qarark_filter_treaties: "Treaties",
    qarark_filter_interpretation: "Interpretation",
    qarark_filter_number: "Legislation number",
    qarark_filter_number_ph: "e.g. 16",
    qarark_filter_year: "Legislation year",
    qarark_filter_year_ph: "e.g. 1960",
    qarark_filter_gazette: "Gazette number",
    qarark_filter_gazette_ph: "e.g. 1487",
    qarark_filter_leg_type: "Legislation type",
    qarark_filter_validity: "Validity",
    qarark_leg_type_all: "All types",
    qarark_leg_type_constitution: "Constitution",
    qarark_leg_type_law: "Law",
    qarark_leg_type_regulation: "Regulation",
    qarark_leg_type_instructions: "Instructions",
    qarark_leg_type_other: "Other",
    qarark_validity_active: "In force",
    qarark_validity_repealed: "Repealed",
    qarark_validity_all: "All",
    qarark_filter_court_number: "Judgment number",
    qarark_filter_court_year: "Judgment year",
    qarark_search_help_btn: "How to search",
    qarark_search_help_title: "How to search and retrieve from Qarark",
    qarark_search_help_intro:
      "Connect your account, describe the legal issue, and let Adl search Qarark and save sources for reading and chat.",
    qarark_search_help_steps_title: "Workflow",
    qarark_search_help_step1:
      "Connect via «Connect Qarark» with your qarark.com subscription credentials (captcha may be required).",
    qarark_search_help_step2:
      "Open «Qarark Research» and describe the legal issue or question you want to investigate.",
    qarark_search_help_step3:
      "Default search type is «Legislation». Search by name (e.g. Penal Code, Labor Law) or use Advanced filters for number and year (e.g. 16 and 1960).",
    qarark_search_help_step4:
      "Open «Advanced filters» to set legislation number, year, gazette number, legislation type (law/regulation…), and validity (in force/repealed).",
    qarark_search_help_step5:
      "Press Search. Up to 10 results appear per page. If more pages exist, click «Load more results» at the bottom of the list.",
    qarark_search_help_step6:
      "Select documents (select all or individually), then «Save selected to library» — Adl downloads the full legislation text from Qarark automatically.",
    qarark_search_help_step7:
      "You can also save a single item with «Save to library» next to each result.",
    qarark_search_help_step8:
      "Open the Chat tab and use «Chat with saved documents» to ask questions about what you saved.",
    qarark_search_help_filters_title: "Search types and filters",
    qarark_search_help_filter1:
      "Legislation (default): best for searching by law name or by legislation number/year.",
    qarark_search_help_filter2:
      "Full content: searches legislation, court judgments, and treaties together — use when Legislation mode finds nothing.",
    qarark_search_help_filter3:
      "Court judgments: choose this type, then enter judgment number and year in Advanced filters.",
    qarark_search_help_filter4:
      "Treaties / Interpretation: search these categories using keywords in the main search field.",
    qarark_search_help_tips_title: "Tips",
    qarark_search_help_tip1:
      "Example: to find the Penal Code — search by name «Penal Code», or number 16 + year 1960 with type «Law».",
    qarark_search_help_tip2:
      "If you get very few hits, try «Full content» or remove some filters.",
    qarark_search_help_tip3:
      "When saving, wait a moment — long laws may take a few seconds to download all articles.",
    qarark_search_help_tip4:
      "If you get no results, confirm Qarark is connected (two-device limit; log out elsewhere on qarark.com if needed).",
    qarark_search_help_tip5:
      "If a document was saved earlier with incomplete text, delete it from the library and save again from Legal search.",
    qarark_select_all: "Select all",
    qarark_save_selected: "Save selected to library",
    qarark_chat_with_saved: "Chat with saved documents",
    qarark_saved_badge: "Saved",
    qarark_saved_count: "Saved {count} document(s)",
    qarark_select_one: "Select at least one document",
    qarark_chat_ready: "Chat context set to your saved documents",
    library_results: "Library Results",
    save_to_library: "Save to library",
    match_semantic: "semantic",
    match_keyword: "keyword",
    download_docx: "Word",
    placeholders: {
      contract: "e.g.: Employment contract between Company X and a lawyer, salary 1500 JOD, term 2 years…",
      memo: "e.g.: Legal memo on validity of lease termination for non-payment…",
      letter: "e.g.: Demand letter giving the debtor 15 days to pay…",
      demand_letter: "e.g.: Demand letter requiring payment of 5,000 JOD within 15 days or legal action…",
      official_letter: "e.g.: Official letter to the enforcement department regarding a judgment…",
      complaint: "e.g.: Statement of claim for breach of contract before Amman Court of First Instance…",
      motion: "e.g.: Defense memorandum replying to statement of claim no. [____]…",
      appeal_memo: "e.g.: Appeal memorandum against the first-instance judgment dated…",
      enforcement_petition: "e.g.: Enforcement request for a final judgment from Amman Court of First Instance…",
      settlement_agreement: "e.g.: Settlement agreement to pay the awarded amount in installments…",
      jurisdiction: {
        JO: "Hashemite Kingdom of Jordan",
        AE: "United Arab Emirates",
        SA: "Kingdom of Saudi Arabia",
        KW: "State of Kuwait",
        BH: "Kingdom of Bahrain",
        OM: "Sultanate of Oman",
        QA: "State of Qatar",
      },
    },
    types: {
      contract: "Contract",
      complaint: "Statement of claim",
      motion: "Defense memorandum",
      appeal_memo: "Appeal memorandum",
      cassation_petition: "Cassation petition",
      enforcement_petition: "Enforcement request",
      court_application: "Court application",
      demand_letter: "Judicial notice",
      memo: "Legal memorandum",
      official_letter: "Official letter",
      settlement_agreement: "Settlement agreement",
      agreement: "Agreement",
      letter: "Letter",
      custom: "Custom",
    },
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState("ar");
  const dir = lang === "ar" ? "rtl" : "ltr";
  const t = useCallback((key) => {
    const parts = key.split(".");
    let v = STRINGS[lang];
    for (const p of parts) v = v?.[p];
    return v ?? key;
  }, [lang]);
  const value = useMemo(() => ({ lang, setLang, dir, t }), [lang, dir, t]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LangProvider");
  return ctx;
}
